
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Principal's Message</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      
<section class="section-lg chair-msg">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="inner-title"  >
                    <h3>Principal's Message</h3>							
                   
                </div>
                <div class="text-justify" >
                    <blockquote>“Success is not final, failure is not fatal; it is the courage to continue that counts.”- Anonymous</blockquote>
                    <p>This is the vision we cater to at the G H Raisoni College of Commerce, Science and Technology. We fabricate an environment which is conducive to learning and inculcated with humane values along with social commitment. In order to assure the quality pertinent for growth, emphasis is laid on our institute pertaining to the quality education along with holistic development. Emotional intelligence is another aspect which never ceases to grow in our education system. Our aim continues to be that of, comprehensive development of our students.</p>
                    <p>The assurance of quality education comes from a high end teaching program, well conveyed by our diligent and dedicated staff. Thereby, care is taken not just to instill the knowledge, but the apt attitude and skills in the students. A plethora of events including social awareness drives international cultural exchange programs and sports leagues are organized round the year in the institute. Thus, imparting the attributes associated with global competencies.</p><p>A college is a vibrant learning community. It encourages an environment which provides with growth being the ladder to accomplish the path called, Accomplishment.</p>
                    <blockquote>My best wishes for the student to benefit from the educational hub we have created.</blockquote>
                </div>
            </div>
            <div class="col-md-4 col-sm-8">
                <div class="team" >
                    <!-- <figure><img class="img-fluid" src="assets/images/team/aarti-deshpande.webp" alt="Dr. Aarti Deshpande" title="Dr. Aarti Deshpande"> </figure> -->
                    <figure><img class="img-fluid" src="assets/images/team/jasvinder_kaur.webp" alt="Dr.Jasvinder-Kaur | Ghrcacsn" title="Dr.Jasvinder-Kaur | Ghrcacsn"> </figure>
                    <div class="team-details">
                        <h5>Dr. Jasvinder Kaur</h5> 
                        <h6>Principal GHRCCST </h6>                                 
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

